<template>
  <article class="Edition" :class="{ 'Edition_show': isShow }">

    <img :src="data.illustration" />
    <h5>{{ data.date }}</h5>
    <h4>{{ data.title }}</h4>

    <a :href="data.link" target="_blank"></a>
    
  </article>
</template>

<script>
  import scrollUpdate from '@/mixins/scrollUpdate'

  export default {
    name: "Edition",
    mixins: [ scrollUpdate ],
    props: [ 'data' ],
    data() {
      return {
        isShow: false
      }
    },
    methods: {
      onVisible()
      {
        this.isShow = true
      }
    }
  }
</script>

<style lang="stylus" scoped>
.Edition

  position relative 
  background: #FFFFFF;
  box-shadow: 0 2px 13px 0 rgba(0,0,0,0.10);
  border-radius: 5px;
  // border-left 4px solid $red
  cursor pointer
  padding 40px 25px
  height 100%
  width 100%
  box-sizing border-box
  text-align center
  display flex
  flex-direction column
  overflow hidden
  align-items center
  justify-content space-between
  transform scale(0.9)
  transform-origin center bottom
  opacity 0.3
  transition box-shadow 0.6s $ease, transform 1.4s 0.2s $back, opacity 0.7s 0.2s $ease

  a

    position absolute
    top 0px
    left 0px
    height 100%
    width 100%
    z-index 2

  &:after

    content ''
    position absolute
    top 0px
    left 0px
    height 100%
    background-color $red
    width 4px
    transition 0.7s $ease

    @media $medium

      width 100%

  &_show

    transform scale(1)
    opacity 1

    &:after

      width 4px

  &:hover

    box-shadow: 0 2px 10px 0 rgba(0,0,0,0.22);

    img

      transform scale(1.15)

  img

    height 55px
    margin 0px auto 20px auto
    transition transform 1s $ease

    // @media $medium

    //   height 80px

  h5

    font-family: $f-content
    font-weight normal
    font-size: 14px;
    color $s1
    letter-spacing: 0;
    line-height: 20px;

  h4

    margin 20px auto auto auto
    width 100%

    @media $medium

      font-size 14px
      line-height 17px

</style>